import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { router } from '@/router'
import { AuthProvider } from '@/contexts/AuthContext'
import { FeedProvider } from '@/contexts/FeedContext'
import { PostProvider } from '@/contexts/PostContext'
import { DraftProvider } from '@/contexts/DraftContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { ChunkErrorBoundary } from '@/components/ui/ChunkErrorBoundary'

function App() {
  return (
    <ChunkErrorBoundary>
    <ThemeProvider>
      <AuthProvider>
        <FeedProvider>
          <PostProvider>
            <DraftProvider>
              <RouterProvider router={router} />
              <Toaster position="top-right" richColors />
            </DraftProvider>
          </PostProvider>
        </FeedProvider>
      </AuthProvider>
    </ThemeProvider>
    </ChunkErrorBoundary>
  )
}

export default App
